module.exports = __webpack_public_path__ + "produce-fresh-grass-main-thumb-02.jpg?d73a0414dbda36b39d9b89b33b980a8c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-main-thumb-02.jpg
// module id = 36
// module chunks = 0